import { Link } from 'react-router-dom';
import SelectLanguage from '../components/SelectLanguage';
import MenuMobileButton from './mobile/MenuMobileButton';
import ToggleButton from '@/partials/inbox/ToggleButton';
import Lucci from '../assets/Logo_horizontal.webp';
import NotificationsButton from './NotificationsButton';
import TimezoneClock from './TimezoneClock';

import useBusinessStore from '../state/businessStore';

import './LayoutHeader.scss';

const LayoutHeader = ({
  title,
  languageToggleActive,
  toggleButtonActive,
  children,
  isGlobalHeader = false,
}) => {
  const { getSelectedBusinessDetails } = useBusinessStore();
  const { selectedBusinessName, selectedBusinessLogo } =
    getSelectedBusinessDetails();

  function acortarTexto(texto, limite = 15) {
    return texto.length > limite ? texto.slice(0, limite) + '...' : texto;
  }

  return (
    <header className="header">
      <div className="header__heading">
        {selectedBusinessName && !isGlobalHeader ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            {selectedBusinessLogo ? (
              <img
                src={selectedBusinessLogo}
                alt="Business logo"
                style={{ height: '30px', borderRadius: '8px' }}
              />
            ) : (
              <h1 className="sidebar__header-business">
                {!selectedBusinessName
                  ? 'Menu'
                  : acortarTexto(selectedBusinessName, 17)}
              </h1>
            )}
          </div>
        ) : (
          <Link to="/">
            <img
              src={Lucci}
              alt="Lucci AI logo"
              style={{
                height: '34px',
              }}
            />
          </Link>
        )}

        <div className="header__center">
          <TimezoneClock />
        </div>

        <div className="buttons">
          <NotificationsButton />
          {children}
          {toggleButtonActive && (
            <ToggleButton
              size="large"
              type="global"
              /* businessId={selectedBusiness.id}
              globalStatus={isGlobalOn}
              onToggleChange={handleGlobalToggleChange} */
            />
          )}
          {languageToggleActive && <SelectLanguage />}
          <MenuMobileButton />
        </div>
      </div>
    </header>
  );
};

export default LayoutHeader;
